import { Button, Col, EntitySnippet, MinusCircleIcon, Row } from 'ui';
import { images } from 'common/utils';
import type { InvitationSearchCommunityOption } from '../../types';
import { InvitationsListSection } from '../invitations-list-section';

type P = {
  invitations: InvitationSearchCommunityOption[];
  onRemove: (communityId: string) => void;
};

const CommunityInvitationsList = ({ invitations, onRemove }: P) => (
  <InvitationsListSection<InvitationSearchCommunityOption>
    getKey={(invitation) => invitation.value}
    items={invitations}
    renderItem={(invitation) => (
      <Row align="middle" gutter="ms" justify="space-between">
        <Col>
          <EntitySnippet
            avatarProps={{
              fallbackPhoto: images.default.communityProfilePhoto,
              photo: invitation.profilePhoto,
              size: 32,
            }}
            descriptionProps={{ children: 'Community' }}
            titleProps={{ children: invitation.label, weight: 'medium' }}
          />
        </Col>
        <Col>
          <Button
            icon={<MinusCircleIcon type="error" />}
            onClick={() => {
              onRemove(invitation.value);
            }}
            type="link-secondary"
          />
        </Col>
      </Row>
    )}
    title="Community Invitations"
  />
);

export default CommunityInvitationsList;
